import Axios from 'axios';
import { API_URL } from '../../../../lib/const';

export const updateAndFetchTransferApplication = async (token: string, payload: object) => {
  const endpoint = `${API_URL}/transfers/applications/${token}`;

  await Axios.patch(endpoint, payload);
  const response = await Axios.get(endpoint);

  return response.data;
};

export const updateTransferRegistration = async (token: string, payload: object) => {
  const endpoint = `${API_URL}/transfers/applications/${token}/update_registration`;

  const response = await Axios.patch(endpoint, payload);

  return response.data;
};

const coordinationDocumentsEndpoint = (token: string) => (
  `${API_URL}/transfers/applications/${token}/coordination_documents`
);

export const fetchCoordinationDocuments = async (token: string) => {
  const response = await Axios.get(coordinationDocumentsEndpoint(token));
  return response.data;
};

export const uploadCoordinationDocument = async (
  token: string,
  kind: string,
  document: object,
  justification?: string,
) => {
  const response = await Axios.post(
    coordinationDocumentsEndpoint(token),
    { kind, document, justification },
  );
  return response.data;
};
